import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import ProductCard from "@/components/ProductCard";
import { Button } from "@/components/ui/button";

export default function WishlistPage() {
  const { wishlist } = useCart();
  const { user } = useAuth();
  if (!user) {
    return (
      <div className="max-w-md mx-auto py-16 px-4 text-center">
        <Heart className="mx-auto brand-text-primary" size={48} />
        <h2 className="font-display text-2xl font-bold mt-4">Login untuk Melihat Wishlist</h2>
        <Link to="/login"><Button className="mt-5 brand-btn-primary rounded-xl">Masuk Sekarang</Button></Link>
      </div>
    );
  }
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
      <h1 className="font-display text-3xl sm:text-4xl font-black">Wishlist</h1>
      <p className="text-sm text-[#5C5C5C] mt-1">Produk favorit yang Anda simpan</p>
      {wishlist.length === 0 ? (
        <div className="bg-white border border-[#E5E5E5] rounded-2xl p-12 mt-6 text-center">
          <Heart className="mx-auto text-[#E5E5E5]" size={48} />
          <div className="mt-3 text-[#5C5C5C]">Wishlist Anda kosong</div>
          <Link to="/katalog"><Button className="mt-4 brand-btn-primary rounded-xl">Lihat Produk</Button></Link>
        </div>
      ) : (
        <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
          {wishlist.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
